export const IMAGES = {
  logo: "/images/logo.webp",
  vadapav: "/images/vadapav.png",
  poha: "/images/poha.png",
  upma: "/images/upma.png",
  shira: "/images/shira.png",
  tea: "/images/tea.png",
  misalpav: "/images/misal-pav.png",
  batataBhaji: "/images/batata-bhaji.png",
  golkandaBhaji: "/images/golkanda-bhaji.png",
  mungBhaji: "/images/mung-bhaji.png",
  palakBhaji: "/images/palak-bhaji.png",
  khekdaBhaji: "/images/khekda-bhaji.png",
  dhokla: "/images/dhokla.png",
  idli: "/images/idli.png",
  balushahi: "/images/balushahi.png",
  mangoLassi: "/images/mango-lassi.png",
  patis: "/images/patis.png",
  pulav: "/images/pulav.png",
  puriBhaji: "/images/puri-bhaji.png",
  samosa: "/images/samosa.png",
  shabuKhichadi: "/images/shabu-khichadi.png",
  shabuVada: "/images/shabu-vada.png",
  udidVada: "/images/udid-vada.png",
};

export const MENU = [
  { id: "vadapav", index: "01", name: "Vada Pav", tagline: "The Original", img: IMAGES.vadapav,
    desc: "A golden batata vada in a soft buttered pav, layered with fiery dry garlic chutney and a fried green chilli.",
    tags: ["Signature", "Veg"] },
  { id: "misalpav", index: "02", name: "Misal Pav", tagline: "Fiery & Famous", img: IMAGES.misalpav,
    desc: "Spicy sprouted usal topped with crunchy farsan, onion and coriander, served with soft pav, lemon and cucumber.",
    tags: ["Spicy", "Signature", "Veg"] },
  { id: "samosa", index: "03", name: "Samosa", tagline: "Tea-time Classic", img: IMAGES.samosa,
    desc: "Crisp, flaky pastry stuffed with spiced potato and peas, served with sweet-red and green chutney.",
    tags: ["Fried", "Snack", "Veg"] },
  { id: "patis", index: "04", name: "Batata Patis", tagline: "Crispy Cutlet", img: IMAGES.patis,
    desc: "Golden potato cutlets, crisp outside and soft within, dusted with dry garlic chutney and chutneys on the side.",
    tags: ["Fried", "Snack", "Veg"] },
  { id: "poha", index: "05", name: "Kanda Poha", tagline: "Morning Ritual", img: IMAGES.poha,
    desc: "Fluffy flattened rice tempered with mustard, curry leaves, onion and roasted peanuts. Light and tangy.",
    tags: ["Breakfast", "Light", "Veg"] },
  { id: "upma", index: "06", name: "Rava Upma", tagline: "Comfort in a Bowl", img: IMAGES.upma,
    desc: "Roasted semolina slow-cooked with ghee, cashews and veggies, finished with fresh coriander.",
    tags: ["Breakfast", "Wholesome", "Veg"] },
  { id: "puribhaji", index: "07", name: "Puri Bhaji", tagline: "Homestyle Plate", img: IMAGES.puriBhaji,
    desc: "Puffy fried puris with a spiced potato bhaji and cooling raita — a satisfying homestyle meal.",
    tags: ["Meal", "Veg"] },
  { id: "idli", index: "08", name: "Idli Sambar", tagline: "Steamed Comfort", img: IMAGES.idli,
    desc: "Pillowy steamed rice cakes with piping-hot sambar and coconut chutney. The wholesome South-Indian staple.",
    tags: ["Breakfast", "Steamed", "Veg"] },
  { id: "shabukhichadi", index: "09", name: "Sabudana Khichadi", tagline: "Upvas Special", img: IMAGES.shabuKhichadi,
    desc: "Pearly sabudana tossed with peanuts, cumin and green chilli — light, nutty and perfect for a fasting day.",
    tags: ["Upvas", "Light", "Veg"] },
  { id: "pulav", index: "10", name: "Veg Pulav", tagline: "Fragrant & Filling", img: IMAGES.pulav,
    desc: "Aromatic basmati rice cooked with mixed vegetables and mild spices, served with raita and spicy gravy.",
    tags: ["Meal", "Rice", "Veg"] },
  { id: "batatabhaji", index: "11", name: "Batata Bhaji", tagline: "Crispy Classic", img: IMAGES.batataBhaji,
    desc: "Potato slices in a spiced gram-flour batter, fried golden and crisp, with sweet-red and green chutney.",
    tags: ["Fried", "Crispy", "Veg"] },
  { id: "khekdabhaji", index: "12", name: "Khekda Bhaji", tagline: "Kurkurit Crunch", img: IMAGES.khekdaBhaji,
    desc: "Thin, lacy and golden crispy onion fritters — the ultimate rainy-day crunch with kadak chai.",
    tags: ["Fried", "Crispy", "Veg"] },
  { id: "palakbhaji", index: "13", name: "Palak Bhaji", tagline: "Green & Crispy", img: IMAGES.palakBhaji,
    desc: "Fresh spinach leaves in a light gram-flour batter fried crisp, served with chutney and dry garlic powder.",
    tags: ["Fried", "Crispy", "Veg"] },
  { id: "mungbhaji", index: "14", name: "Mung Bhaji", tagline: "Dal Delight", img: IMAGES.mungBhaji,
    desc: "Protein-rich moong-dal fritters, crisp outside and fluffy within — a wholesome tea-time bite.",
    tags: ["Fried", "Protein", "Veg"] },
  { id: "golkandabhaji", index: "15", name: "Golkanda Bhaji", tagline: "Crunch Bombs", img: IMAGES.golkandaBhaji,
    desc: "Soft-centred gram-flour fritters fried to a deep golden crunch, dusted with dry garlic chutney.",
    tags: ["Fried", "Snack", "Veg"] },
  { id: "shabuvada", index: "16", name: "Sabudana Vada", tagline: "Upvas Crunch", img: IMAGES.shabuVada,
    desc: "Crispy sabudana and potato patties studded with peanuts, served with cooling curd dip.",
    tags: ["Upvas", "Fried", "Veg"] },
  { id: "udidvada", index: "17", name: "Medu Vada", tagline: "Crispy Doughnut", img: IMAGES.udidVada,
    desc: "Golden urad-dal vadas dunked in warm sambar with coconut chutney — crisp outside, soft inside.",
    tags: ["Fried", "Breakfast", "Veg"] },
  { id: "dhokla", index: "18", name: "Dhokla", tagline: "Steamed & Light", img: IMAGES.dhokla,
    desc: "Soft, spongy steamed gram-flour cake with a light tempering — served with sweet and green chutney.",
    tags: ["Steamed", "Light", "Veg"] },
  { id: "shira", index: "19", name: "Sooji Shira", tagline: "Sweet Nostalgia", img: IMAGES.shira,
    desc: "Semolina roasted in pure ghee, sweetened just right and studded with cashews and plump raisins.",
    tags: ["Sweet", "Festive", "Veg"] },
  { id: "balushahi", index: "20", name: "Balushahi", tagline: "Sweet Indulgence", img: IMAGES.balushahi,
    desc: "A flaky, deep-fried classic soaked in sugar syrup — golden, glossy and melt-in-the-mouth.",
    tags: ["Sweet", "Festive", "Veg"] },
  { id: "mangolassi", index: "21", name: "Mango Lassi", tagline: "Chilled & Creamy", img: IMAGES.mangoLassi,
    desc: "Thick, creamy yoghurt blended with sweet mango — chilled, smooth and sunshine in a glass.",
    tags: ["Beverage", "Cold", "Sweet"] },
  { id: "tea", index: "22", name: "Cutting Chai", tagline: "Adrak Kadak", img: IMAGES.tea,
    desc: "Strong, frothy and brewed with real ginger — the tapri-style chai that fuels every conversation.",
    tags: ["Beverage", "Ginger", "Hot"] },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "100% Genuine Ingredients",
    body:
      "Fresh local produce, quality spices and Gemini refined oil — never frozen, never compromised. Food we're proud to serve our own family.",
  },
  {
    num: "02",
    title: "Under-5-Minute Promise",
    body:
      "Our kitchens are tuned for the rush. Your order is hot and ready in under five minutes — every single time.",
  },
  {
    num: "03",
    title: "A Full Menu, Made Fresh",
    body:
      "From the iconic vada pav to poha, misal, dhokla and cutting chai — 20+ favourites, each prepared fresh to order.",
  },
  {
    num: "04",
    title: "Loved Across Pune",
    body:
      "13 outlets across Pimpri-Chinchwad & Pune, serving 20,000+ plates and growing — rooted in the community that feeds us.",
  },
];

export const STATS = [
  { value: "20,000+", label: "Plates served" },
  { value: "13", label: "Outlets & counting" },
  { value: "5 Min", label: "Average serve time" },
  { value: "100%", label: "Genuine ingredients" },
];

export const CONTACT = {
  name: "Shree Siddhivinayak Vada Pav",
  nameMarathi: "श्री सिद्धीविनायक वडापाव",
  taglineMarathi: "पिंपरी चिंचवडचा प्रसिद्ध वडापाव",
  short: "SSV",
  address:
    "Pimpri-Chinchwad, Pune, Maharashtra.",
  hours: "All Days · 05:00 AM – 10:00 PM",
  instagram: "https://www.instagram.com/shree.siddhivinayak.vadapav/",
  facebook: "",
  mapsQuery:
    "Shri+Siddhivinayak+Vada+Pav+Pune",
};

export const BRANCHES = [
  { slug: "nehrunagar", name: "Nehrunagar", address: "Nehrunagar, Pimpri-Chinchwad, Pin 411018", lat: 18.671819, lng: 73.78674, opened: "" },
  { slug: "indrayani-nagar", name: "Indrayani Nagar", address: "Near Kunal Wine, Bhosari MIDC, Pin 411026", lat: 18.632448, lng: 73.837542, opened: "" },
  { slug: "talwade", name: "Talwade", address: "Tower Line, Triveni Nagar, Talwade, Pin 411062", lat: 18.671833, lng: 73.786753, opened: "" },
  { slug: "moshi-toll-naka", name: "Moshi Toll Naka", address: "Gaikwad Wasti, Opp Toll Naka, Moshi, Pin 412105", lat: 18.68602, lng: 73.846482, opened: "18 Jan 2019" },
  { slug: "charoli-phata", name: "Charoli Phata", address: "Charoli Phata, Pin 412105", lat: 18.66182, lng: 73.886976, opened: "15 Feb 2021" },
  { slug: "pimple-saudagar", name: "Pimple Saudagar", address: "Opp P K BRT Bus Stop, Pimple Saudagar, Pin 411027", lat: 18.597919, lng: 73.799269, opened: "07 Oct 2021" },
  { slug: "old-sangavi", name: "Old Sangavi", address: "Makan Chowk, Old Sangavi, Pin 411027", lat: 18.576034, lng: 73.819765, opened: "09 Jun 2022" },
  { slug: "laxmi-chowk-moshi", name: "Laxmi Chowk, Moshi", address: "Laxmi Chowk, Moshi, Pin 412105", lat: 18.679803, lng: 73.834717, opened: "10 Nov 2022" },
  { slug: "morwadi", name: "Morwadi", address: "Finolex Chowk, Morwadi, Pimpri, Pin 411018", lat: 18.629028, lng: 73.802856, opened: "22 Jun 2023" },
  { slug: "pimpri-gaon", name: "Pimpri Gaon", address: "Tapovan Mandir Road, Pimpri Gaon, Pin 411018", lat: 18.611943, lng: 73.800836, opened: "27 Jul 2023" },
  { slug: "bajirao-road", name: "Bajirao Road", address: "Opp Maharana Pratap Garden, Bajirao Road, Pune 411002", lat: 18.508735, lng: 73.853869, opened: "11 Jul 2024" },
  { slug: "ambethan-chowk", name: "Ambethan Chowk", address: "Ambethan Chowk, Chakan, Pin 410501", lat: 18.763586, lng: 73.861206, opened: "16 Jan 2025" },
  { slug: "dhanori-jakat-naka", name: "Dhanori Jakat Naka", address: "Dhanori Jakat Naka, Dhanori, Pin 411032", lat: 18.596794, lng: 73.908176, opened: "19 Mar 2026" },
];

export const getBranchBySlug = (slug) =>
  BRANCHES.find((b) => b.slug === slug) || null;

